import { Injectable } from '@angular/core';
import { FilterService } from '../../../core/services/core.filter.service';
import { GfTranslateService } from '../../../core/services/core.translate.service';

import * as _ from 'lodash';

@Injectable()
export class FrsReleaseBrowseService {
    constructor(
        private filterService: FilterService,
        private gfTranslateService: GfTranslateService
    ) {}

    getSortFields() {
        return {
            'releaseDate': this.gfTranslateService.translate('Release Date'),
            'packageName': this.gfTranslateService.translate('Package Name'),
            'releaseName': this.gfTranslateService.translate('Release Name')
        };
    }

    getAnyFilterObj() {
        return { id: '', label: this.gfTranslateService.translate("Any"), defaultSelected: true };
    }

    getPackageFilterList(packages: any) {
        return [this.getAnyFilterObj()].concat(_.map(packages, function (p) {
            return { id: p.id, label: p.packageName, defaultSelected: false };
        }));
    }

    getBaseFilters(packages, canSubmit) {
        var any = this.filterService.getAnyFilterObj();

        var releasedDefault = { id: 'Y', label: "Released", defaultSelected: true };
        if (canSubmit) {
            releasedDefault = this.filterService.getAnyFilterObj();
        }

        return [
            { alias: '_textsearch', fieldName: this.gfTranslateService.translate("Text search"), value: "", fieldType: 4, isExtraField: false },
            { alias: "packageId", fieldName: this.gfTranslateService.translate("Package"), value: any, fieldType: 1, isExtraField: false, fieldElements: this.getPackageFilterList(packages) },
            { alias: "isVisible", fieldName: this.gfTranslateService.translate("Visible"), value: any, fieldType: 1, isExtraField: false, fieldElements: [{ id: '', label: this.gfTranslateService.translate("Any") }, { id: 'Y', label: this.gfTranslateService.translate("Visible") }, { id: 'N', label: this.gfTranslateService.translate("Hidden") }] },
            { alias: "isPublic", fieldName: this.gfTranslateService.translate("Public"), value: any, fieldType: 1, isExtraField: false, fieldElements: [{ id: '', label: this.gfTranslateService.translate("Any") }, { id: 'Y', label: this.gfTranslateService.translate("Public") }, { id: 'N', label: this.gfTranslateService.translate("Private") }] },
            { alias: "isReleased", fieldName: this.gfTranslateService.translate("Released"), value: releasedDefault, fieldType: 1, isExtraField: false, fieldElements: [{ id: '', label: this.gfTranslateService.translate("Any") }, { id: 'Y', label: this.gfTranslateService.translate("Released") }, { id: 'N', label: this.gfTranslateService.translate("Unreleased") }] },
            { alias: "releaseDateFrom", fieldName: this.gfTranslateService.translate("From"), value: "", fieldType: 9, isExtraField: false },
            { alias: "releaseDateTo", fieldName: this.gfTranslateService.translate("To"), value: "", fieldType: 9, isExtraField: false }
        ];
    }    
}